import { $, $$ } from '../helper/utils';
export class ProductShowcase {

    targetElm = null;
    interactableElm = null;

    copyElement = null;
    isPlaying = false;
    canClose = false;

    containerwidthMax = 1750

    constructor(interactableElm) {
        this.interactableElm = interactableElm;
        //get the data-target element as target id
        const targetId = this.interactableElm.dataset.target;
        if (!targetId) return;

        this.targetElm = document.getElementById(targetId);
        if (this.targetElm && this.interactableElm) {
            this.init();
            this.initEventListeners();
        }
    }

    init() {
        setTimeout(() => {
            this.targetElm.removeAttribute('hidden');
        }, 200);
    }

    initEventListeners() {
        this.interactableElm.addEventListener('click', this.open.bind(this));
        this.targetElm.querySelector('.close').addEventListener('click', this.close.bind(this));
        //check esc key press
        window.addEventListener('keyup', (e) => {
            if (e.keyCode === 27) {
                this.close();
            }
        });
    }

    open() {

        if (this.isPlaying) return;
        this.isPlaying = true;


        this.smoothScrollToTop();
        let scrollbarWidth = (window.innerWidth - document.body.clientWidth);
        
        $('html').classList.add('noscroll');
        //add a padding right to the body with the width of the scrollbar
        console.log(scrollbarWidth);
        document.body.style.paddingRight = `${scrollbarWidth}px`;

        setTimeout(() => {
            let offset = 0;
            if (this.containerwidthMax < window.innerWidth) {
                offset = window.innerWidth - this.containerwidthMax;
            }

            //check if left or right
            //check if interactable element is left half or right half of the screen
            const rectEl = this.interactableElm.getBoundingClientRect();
            const halfHeight = this.interactableElm.offsetHeight / 2;
            const halfWidth = this.interactableElm.offsetWidth / 2;
            const left = rectEl.left + halfWidth;
            const right = window.innerWidth - left;

            const isLeft = left < right;

            this.interactableElm.style.zIndex = 11;
            this.interactableElm.querySelector('.product-text-wrap').style.opacity = '0';
            //clone the interactable element
            this.copyElement = this.interactableElm.cloneNode(true);
            this.copyElement.style.opacity = 0;
            //disable interaction
            this.copyElement.style.pointerEvents = 'none';
            //append the clone next to the interactable element
            this.interactableElm.style.position = 'fixed';
            this.interactableElm.parentNode.insertBefore(this.copyElement, this.interactableElm.nextSibling);

            //get the position if the interactable element
            const rect = this.copyElement.getBoundingClientRect();
            //set the interactable element position to absolute

            //set the interactable element position to the current position
            this.interactableElm.style.top = `${rect.top - (halfHeight - 35)}px`;
            if (isLeft) {
                this.interactableElm.style.left = `${rect.left}px`;
            } else {
                this.interactableElm.style.left = `${rect.left}px`;
            }

            //set the width and height to the current width and height
            this.interactableElm.style.width = `${rect.width}px`;
            this.interactableElm.style.height = `${rect.height}px`;




            setTimeout(() => {
                //remove style
                this.interactableElm.style.transition = `all 0.3s ease-in-out`;
                this.interactableElm.classList.add('active');
                this.showBubbles();
            }, 50);


            setTimeout(() => {
                this.interactableElm.classList.add('full-scale');
            }, 200);

            setTimeout(() => {
                this.canClose = true;                
            }, 600);


            this.targetElm.classList.add('is-open');

        }, 250);

    }

    close() {
        //remove the clone element
        if (this.copyElement == null) return;
        if (!this.canClose) return;
        this.canClose = false;

        let offset = 0;
        if (this.containerwidthMax < window.innerWidth) {
            offset = window.innerWidth - this.containerwidthMax;
        }
        //check if left or right
        //check if interactable element is left half or right half of the screen
        const rectEl = this.interactableElm.getBoundingClientRect();
        const halfHeight = this.interactableElm.offsetHeight / 2;
        const halfWidth = this.interactableElm.offsetWidth / 2;
        const left = rectEl.left + halfWidth;
        const right = window.innerWidth - left;

        const isLeft = left < right;

        const rect = this.copyElement.getBoundingClientRect();

        //set the interactable element position to absolute
        this.interactableElm.style.position = 'absolute';
        //set the interactable element position to the current position
        this.interactableElm.style.top = `${rect.top - (65)}px`;

        if (isLeft) {
            this.interactableElm.style.left = `${rect.left - offset / 2}px`;
        } else {
            this.interactableElm.style.left = `${rect.left - offset}px`;
        }

        //set the width and height to the current width and height
        this.interactableElm.style.width = `${rect.width}px`;
        this.interactableElm.style.height = `${rect.height}px`;

        this.interactableElm.style.zIndex = 30;

        this.interactableElm.classList.remove('active');
        this.targetElm.classList.remove('is-open');

        setTimeout(() => {
            this.interactableElm.classList.remove('full-scale');
        }, 50)

        setTimeout(() => {
            //remove style
            this.interactableElm.removeAttribute('style');
            this.copyElement.parentNode.removeChild(this.copyElement);
            this.copyElement = null;
            this.interactableElm.querySelector('.product-text-wrap').removeAttribute('style');
            if (this.interactableElm.classList.contains('pinacolada-linked-image')) {
                this.interactableElm.style.zIndex = 2;
            } else {
                this.interactableElm.style.zIndex = 1;
            }
            this.hideBubbles();

        }, 300);

        setTimeout(() => {
            $('html').classList.remove('noscroll');
            document.body.style.paddingRight = '';
            this.isPlaying = false;
        }, 450);

    }

    smoothScrollToTop() {
        const scrollDuration = 100;
        const scrollStep = -window.scrollY / (scrollDuration / 15);
        const scrollInterval = setInterval(() => {
            if (window.scrollY !== 0) {
                window.scrollBy(0, scrollStep);
            } else {
                clearInterval(scrollInterval);
            }
        }, 15);
    }

    showBubbles() {
        //get the bubbles add a class to increase z-index
        $$('.bubble').forEach((el) => {
            const random = Math.floor(Math.random() * 3) + 10;
            el.style.zIndex = random;
        });
    }

    hideBubbles() {
        //get the bubbles remove the class to decrease z-index
        $$('.bubble').forEach((el) => {
            el.removeAttribute('style');
        });
    }

}

export default () => {
    $$('.linked-product').forEach((el) => {
        new ProductShowcase(el)
    });
}